/**
 * Title Slide Component
 * Reusable title slide with custom red background and centered text
 */

import React from 'react';
import { SlideNavigation } from '../shared/Navigation';
import { TitleSlideData, NavigationProps } from '../../types/slideTypes';

interface TitleSlideProps extends NavigationProps {
  data: TitleSlideData;
}

export const TitleSlide: React.FC<TitleSlideProps> = ({
  data,
  currentSlide,
  totalSlides,
  onGoToSlide,
}) => {
  return (
    <div className="w-full h-full relative overflow-hidden flex flex-col" style={{ background: '#FFFFFF' }}>
      {/* Main Content - Centered */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 md:px-6 lg:px-8">
        <div className="text-center max-w-5xl mx-auto space-y-6 md:space-y-8">
          <div className="space-y-4 md:space-y-6">
            <h1
              className="font-bold text-black leading-tight tracking-tight"
              style={{ fontSize: 'clamp(2rem, 5vw, 3rem)' }}
            >
              {data.title}
            </h1>
            <h2
              className="text-black font-light leading-relaxed max-w-3xl mx-auto"
              style={{ fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)' }}
            >
              {data.subtitle}
            </h2>
          </div>

          <div className="space-y-4">
            {data.presenter && (
              <p className="text-lg font-medium text-black">{data.presenter}</p>
            )}
            {data.date && (
              <p className="text-base font-medium text-black">{data.date}</p>
            )}
          </div>
        </div>
      </div>

      {/* Logo - Aligned with Content Slides - Responsive */}
      <div className="absolute top-12 left-0 right-0">
        <div className="max-w-7xl mx-auto pl-4 md:pl-8 lg:pl-[116px]">
          <img src="/assets/logo_black.png" alt="Logo" className="max-w-[200px]" />
        </div>
      </div>

      {/* 50px Dark Footer - GPU accelerated gradient */}
      <div
        className="absolute bottom-0 w-full"
        style={{
          height: '50px',
          background: 'linear-gradient(180deg, #1a1a1a 0%, #2d2d2d 100%)',
          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.3)',
          willChange: 'transform',
          transform: 'translateZ(0)',
        }}
      />

      {/* Floating Navigation */}
      <SlideNavigation
        currentSlide={currentSlide}
        totalSlides={totalSlides}
        onGoToSlide={onGoToSlide}
      />
    </div>
  );
};
